import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/vipImg/popup_vip_new_tag@2x.png'


const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "con" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "header-tag" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = { class: "header-title" }
const _hoisted_6 = { class: "content-c flex cen -col" }
const _hoisted_7 = { class: "notice" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  class: "mt_20 mb_0",
  style: {}
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = {
  href: "/d2c/article/2/68",
  class: "link-text",
  target: "_blank"
}

import { ref, onMounted, computed } from 'vue'
import { t } from '@/plugins/i18n'
import { useRtfix, isD2C } from '@/store'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ArrowRight } from '@element-plus/icons-vue'
import { getMemberRemind, getMemberRemindRead } from '@/apis/membership'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const membership = store.getters.membership
const isSub = store.getters.isSub
const expiresDate = computed(() => {
  const str = membership.expiresDate?.split(' ')[0].split('-')
  return str[0] + '年' + str[1] + '月' + str[2] + '日'
})
const dialogVisible = ref(false) // 是否显示
onMounted(() => {
  getIsNewMembership()
})

// 会员规则变更通知弹窗的实现
const getIsNewMembership = () => {
  getMemberRemind({
    superCustomerId: membership.superCustomerId
  }).then((res: any) => {
    if (res.code === '0') {
      dialogVisible.value = res.data
    }
  })
}

const closeModal = (type: number) => {
  // 已读弹窗
  getMemberRemindRead({
    superCustomerId: membership.superCustomerId
  }).then(() => {
    dialogVisible.value = false
  })
  if (type === 2) router.push(useRtfix('VipLevel'))
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      width: "600px",
      "custom-class": "memberchange",
      "close-on-click-modal": false,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (closeModal(1)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('会员规则变更通知')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", {
                class: "mt_0 mb_0",
                innerHTML: _unref(t)('尊敬的用户，THE CKB团队经过谨慎考虑，为了更好的为用户提供服务，决定在经历了一段时间的免费运营后，于2023/1/11开始只对付费会员提供服务。')
              }, null, 8, _hoisted_8),
              _createElementVNode("p", {
                class: "mt_20 mb_0",
                innerHTML: _unref(t)('您也不用担心，您是陪伴我们成长的首批用户，我们已为您自动升级到新会员，并且免费送您会员到1月31日（原价1980日元/月)！赶快去试用体验吧！')
              }, null, 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  innerHTML: _unref(t)('到期后会员将失效，将无法享受下单服务，欢迎随时充值新会员。')
                }, null, 8, _hoisted_11),
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("a", _hoisted_14, _toDisplayString(_unref(t)('新会员权益介绍')), 1)
              ])
            ])
          ]),
          _createVNode(_component_el_button, {
            class: "btn mt_20",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal(2)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(isSub) ?_unref(t)('查看新会员'):_unref(t)('开通新会员')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})